import { FileService } from '../../services/fileApiService';

/** Shared {@link FileService} instance for list fetches, offline checks, and WebSocket follow-up loads under `useFiles`. */
export const fileService = new FileService();
